/*global define:false*/
define('forbiddenView',['grasshopperBaseView', 'forbiddenViewConfig'],
    function (GrasshopperBaseView, forbiddenViewConfig) {
        'use strict';

        return GrasshopperBaseView.extend({
            defaultOptions: forbiddenViewConfig
        });

    });

